import type { Nullable, Optional } from '@gov-nx/core/types/helpers.types';
import { is, isNumber } from '@gov-nx/core/types/helpers.types';

export const replaceVariablesInUrl = (
	inputString: string,
	valueObject: Nullable<Record<string, Optional<string | number>>>
): string => {
	const queryParams: string[] = [];

	if (typeof valueObject === 'object') {
		for (const key in valueObject) {
			if (Object.prototype.hasOwnProperty.call(valueObject, key)) {
				const value = valueObject[key];
				const colonKey = `:${key}`;
				const optionalKey = `${colonKey}?`;

				if (inputString.includes(colonKey)) {
					if (is(value)) {
						inputString = inputString.replace(
							colonKey,
							isNumber(value) ? value.toString() : value
						);
					} else {
						inputString = inputString.includes(optionalKey)
							? inputString.replace(optionalKey, '')
							: inputString.replace(colonKey, '');
					}
				} else if (is(value)) {
					queryParams.push(`${key}=${value}`);
				}
			}
		}
	}

	if (inputString.length > 1 && inputString.endsWith('/')) {
		inputString = inputString.slice(0, -1);
	}

	if (queryParams.length > 0) {
		const queryString = queryParams.join('&');
		inputString += inputString.includes('?')
			? `&${queryString}`
			: `?${queryString}`;
	}

	return inputString;
};
